<template>
  <section v-show="facilities.length || extrasNonSimple.length">
    <translate tag="h4"> Features </translate>
    <div class="facilities">
      <template v-for="feature of electricFacilities" :key="feature.name">
        <div class="row">
          <img
            loading="lazy"
            class="tick"
            src="@/assets/images/tick.svg"
            width="15"
            height="13"
            alt=""
          />
          <span
            class="facility"
            :class="{ 'electric-extra': !feature.included }"
          >
            <span
              ><template v-if="feature.slug === 'electric-other'"
                >Electric: </template
              >{{ feature.name }}</span
            >
            <span class="facility-rules">
              <translate v-if="feature.included">included</translate>
              <translate v-else>extra cost</translate>
            </span>
          </span>
        </div>
      </template>
      <template v-for="extra of extrasNonSimple" :key="extra.name">
        <div class="row">
          <img
            loading="lazy"
            class="tick"
            src="@/assets/images/tick.svg"
            width="15"
            height="13"
            alt=""
          />
          <span class="facility">
            <span>{{ extra.name }}</span>
            <translate
              class="facility-rules"
              :tt="{ count: extra.included, max: extra.max }"
              >{count} included, {max} max.
            </translate>
          </span>
        </div>
      </template>
      <template v-for="feature of nonElectricFacilities" :key="feature.name">
        <div class="row">
          <img
            loading="lazy"
            class="tick"
            src="@/assets/images/tick.svg"
            width="15"
            height="13"
            alt=""
          />
          <span class="facility">
            <span
              >{{ feature.name }}
              <pu-popover
                v-if="
                  feature.notes || (feature.photo && feature.photo.master_image)
                "
              >
                <template #content>
                  <h4>{{ feature.name }}</h4>
                  <img
                    v-if="feature.photo && feature.photo.master_image"
                    loading="lazy"
                    :src="`/_cfi/cdn-cgi/image/f=auto,fit=cover,g=auto,quality=80,w=360,h=270${feature.photo.master_image}`"
                    :srcset="`/_cfi/cdn-cgi/image/format=auto,fit=cover,quality=80,w=360,h=270${feature.photo.master_image} 360w, /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=70,w=720,h=540${feature.photo.master_image} 720w, /_cfi/cdn-cgi/image/format=auto,fit=cover,quality=60,w=1080,h=810${feature.photo.master_image} 1080w`"
                    :alt="feature.name"
                    width="300"
                    height="225"
                    class="feature-photo"
                  />
                  <p v-if="feature.notes" class="feature-description">
                    {{ feature.notes }}
                  </p>
                </template>
              </pu-popover></span
            >
          </span>
        </div>
      </template>
    </div>
  </section>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import {
  ExtraNonSimple,
  PitchTypeFacility,
} from '../../../../campsite-details/types'

@Component
class Facilities extends Vue {
  @Prop()
  facilities: PitchTypeFacility[]

  @Prop()
  extrasNonSimple: ExtraNonSimple[]

  get electricFacilities(): PitchTypeFacility[] {
    return this.facilities.filter(
      (feature) => feature.isSimple && feature.allowed && feature.isElectric,
    )
  }

  get nonElectricFacilities(): PitchTypeFacility[] {
    return this.facilities.filter(
      (feature) => feature.isSimple && feature.allowed && !feature.isElectric,
    )
  }
}

export default toNative(Facilities)
</script>

<style scoped>
section {
  margin: 1.3em 0;
}

.facilities {
  font-size: var(--body);
  column-gap: 1em;
  columns: 16ch 3;
}

.row {
  padding: 0.25em 0;
  align-items: self-start;
  break-inside: avoid;
}

.facility {
  align-items: flex-start;
  display: flex;
  flex-basis: 100%;
  flex-direction: column;
  justify-content: space-between;
  line-height: 1.15;
}

.feature-description {
  margin: 0.5em 0 0 0;
  line-height: 1.2;
  white-space: pre-line;
}

.feature-photo {
  width: 100%;
}

.facilities .facility-rules {
  font-size: var(--small);
  color: var(--colour-text-light);
  flex-shrink: 1;
  padding-left: 0;
}

.tick {
  width: 0.8em;
  margin: 0.25em 0.25em 0 0;
}

.electric-extra .facility-rules {
  font-weight: bold;
  color: var(--colour-red);
}
</style>
